import { getCloudinary } from "shared/cloudinary";

export const getCloudinaryImageUrl = (
  imageId: string | null | undefined,
  transformation: string,
): string | null => {
  if (!imageId) return null;

  try {
    return getCloudinary(imageId).image(imageId).addTransformation(transformation).toURL();
  } catch {
    return null;
  }
};
